import React, { useEffect } from 'react';

const ProductFruitHelpdesk = () => {
    useEffect(() => {
        const userEmail = localStorage.getItem('email');
        if (
            userEmail &&
            process.env.REACT_APP_VITE_PRODUCT_FRUIT_WORKSPACE &&
            process.env.REACT_APP_VITE_PRODUCT_FRUIT_WORKSPACE !== 'null'
        ) {
            const workspaceCode = process.env.REACT_APP_VITE_PRODUCT_FRUIT_WORKSPACE as string;
            const languageCode = 'en';
            const user = { username: userEmail };
            initializeProductFruits(workspaceCode, languageCode, user);
        }
    }, []);

    useEffect(() => {
        notifyPageChange();
    }, [location.pathname]);

    const initializeProductFruits = (workspaceCode: string, languageCode: string, user: any) => {
        try {
            if (typeof window === 'undefined') return;

            (window as any).$productFruits = (window as any).$productFruits || [];

            (window as any).$productFruits?.push([
                'init',
                workspaceCode,
                languageCode,
                { username: user.username },
                { disableLocationChangeDetection: true, hideInAppCenterLauncher: true },
                {
                    helpdesk: {
                        enabled: true,
                        key: process.env.REACT_APP_PRODUCT_FRUIT_HELPDESK_KEY, // 👈 Replace with your helpdesk key
                    },
                },
            ]);
        } catch (error) {
            console.log(error);
            throw error;
        }
    };

    const notifyPageChange = () => {
        if ((window as any).$productFruits && (window as any).$productFruits.length) {
            (window as any).$productFruits.push(['pageChanged']);
        }
    };

    return null;
};

export default ProductFruitHelpdesk;
